export enum HttpCustomStatus {
  RESOURCE_ALREADY_EXISTS = 230,
  CUSTOM_API_EXCEPTION = 231,
  SESSION_MISMATCH = 440
}
